import { Address } from '@mirai-kids-monte/core/src/constants/Address';
import { Company } from '@mirai-kids-monte/core/src/constants/Company';
import { SiteUrl } from '@mirai-kids-monte/core/src/constants/SiteUrl';
import { type Organization, type Person, type Preschool, type WebSite, type WithContext } from 'schema-dts';
import { PageUrl } from './PageUrl';

const BASE_URL = SiteUrl.WEB;
export const BUSINESS_NAME = 'みらいキッズモンテプリスクール';
const BUSINESS_ID = `${BASE_URL}/daycare/#preschool`;
const ORGANIZATION_ID = `${BASE_URL}/#organization`;
const FOUNDER_ID = `${BASE_URL}/daycare/teachers/#tanaka-yoko`;

export const websiteSchema: WithContext<WebSite> = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${BASE_URL}/#website`,
  name: BUSINESS_NAME,
  alternateName: ['みらいキッズモンテ', 'mirai-kids-monte.com'],
  url: `${BASE_URL}/`,
  publisher: { '@id': ORGANIZATION_ID },
};

export const businessSchema: WithContext<Exclude<Preschool, string>> = {
  '@context': 'https://schema.org',
  '@type': 'Preschool',
  '@id': BUSINESS_ID,
  name: BUSINESS_NAME,
  url: `${BASE_URL}/`,
  description:
    '神戸市灘区のモンテッソーリ認可外保育施設（無償化対象）。モンテ歴20年以上の講師が代表を務め、英語・リトミック・クッキング・体育・華道を含む6本柱の教育プログラムを提供。定員14名の少人数制で1〜5歳を対象。',
  telephone: Company.PHONE,
  openingHours: Company.OPENING_HOURS,
  image: [
    `${BASE_URL}/img/image-montessori-tools-together.webp`,
    `${BASE_URL}/img/image-free-space.webp`,
    `${BASE_URL}/img/image-montessori.webp`,
    `${BASE_URL}/img/image-montessori-tool-1.webp`,
    `${BASE_URL}/img/kids-cource-image.webp`,
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: Address.MONTE_SPACE_STREET,
    addressLocality: Address.MUNICIPALITY,
    addressRegion: Address.PREFECTURE,
    postalCode: Company.POSTAL_CODE,
    addressCountry: Address.COUNTRY_CODE,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.71034709736502,
    longitude: 135.22541341979556,
  },
  parentOrganization: { '@id': ORGANIZATION_ID },
};

export const organizationSchema: WithContext<Organization> = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: Company.NAME,
  legalName: Company.NAME,
  url: `${BASE_URL}/`,
  founder: { '@id': FOUNDER_ID },
};

export const founderSchema: WithContext<Person> = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': FOUNDER_ID,
  name: Company.CEO,
  url: `${BASE_URL}${PageUrl.DAYCARE_TEACHERS}`,
  image: `${BASE_URL}/img/yoko.webp`,
  jobTitle: ['ミライウォーク株式会社 代表取締役', 'みらいキッズモンテプリスクール 園長', 'モンテッソーリ教師'],
  worksFor: { '@id': BUSINESS_ID },
  sameAs: [PageUrl.INSTAGRAM_ACCOUNT],
  knowsAbout: ['モンテッソーリ教育', '幼児教育', '子育て支援'],
};
